import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1100,
    width: '100%',
    margin: '0 auto',
  },
  dialog: {
    width: '90vw',
    maxWidth: 800,
    minWidth: 320,
    height: '90vh',
    maxHeight: '90vh',
    [theme.breakpoints.down('md')]: {
      width: '95vw',
      height: '95vh',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
      height: '80vh',
      maxWidth: 'none',
      maxHeight: 'none',
      margin: 0,
    },
  },
  dialogContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
  },
  section: {
    marginBottom: theme.spacing(1),
  },
}));
